import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center p-1 pr-0" }
const _hoisted_2 = { class: "rotate-90 w-8 self-start origin-center ml-1 my-3" }

import { computed, ref, onMounted, watch } from "vue";
import { colord } from "colord";
import { RGB8, rgb8AsDict, rgb8AsArray } from "@/keyboard";

const canvasWidth = 200;

export default /*@__PURE__*/_defineComponent({
  __name: 'ColorPicker',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const canvasHeight = canvasWidth;

const color = computed(() => colord(rgb8AsDict(props.modelValue)));
const hexColor = computed(() => color.value.toHex());
const colorHsv = computed(() => color.value.toHsv());

// Hue must be kept separately to avoid random changes. Just use correct initial value.
const hue = ref(colorHsv.value.h);

// Must keep marker position to avoid marker jumps due to quantization
const markerX = ref((colorHsv.value.s / 100) * canvasWidth);
const markerY = ref((1 - colorHsv.value.v / 100) * canvasHeight);

onMounted(() => {
  hue.value = colorHsv.value.h;
  markerX.value = (colorHsv.value.s / 100) * canvasWidth;
  markerY.value = (1 - colorHsv.value.v / 100) * canvasHeight;
});

const clamp = (val: number, min: number, max: number) =>
  Math.max(min, Math.min(max, val));

const outputColor = computed(() => {
  const [x, y] = [
    clamp(markerX.value / canvasWidth, 0, 1),
    clamp(markerY.value / canvasHeight, 0, 1),
  ];
  const hsv = {
    h: hue.value,
    s: x * 100,
    v: (1 - y) * 100,
  };
  return colord(hsv);
});

// Covers all color changes as outputColor changes when xy change OR hue changes.
watch(outputColor, (color) => {
  const rgb8 = rgb8AsArray(color.toRgb());
  emit("update:modelValue", rgb8);
});

const moveMarker = (e: MouseEvent, condition: boolean) => {
  if (!condition) return;

  const elem = e.target as HTMLElement;
  const rect = elem.getBoundingClientRect();

  markerX.value = e.x - rect.left;
  markerY.value = e.y - rect.top;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "picker-gradient",
      style: _normalizeStyle({
        color: `hsl(${hue.value}, 100%, 50%)`,
        width: `${canvasWidth}px`,
        height: `${_unref(canvasHeight)}px`,
      }),
      onMousedown: _cache[0] || (_cache[0] = (e) => moveMarker(e, (e.buttons & 1) != 0)),
      onMousemove: _cache[1] || (_cache[1] = (e) => moveMarker(e, (e.buttons & 1) != 0)),
      onMouseup: _cache[2] || (_cache[2] = (e) => moveMarker(e, e.button == 1)),
      onMouseleave: _cache[3] || (_cache[3] = (e) => moveMarker(e, (e.buttons & 1) != 0))
    }, [
      _createElementVNode("div", {
        class: "picker-marker",
        style: _normalizeStyle({
          'background-color': hexColor.value,
          left: `${markerX.value}px`,
          top: `${markerY.value}px`,
        })
      }, null, 4)
    ], 36),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "hue-slider h-3",
        style: _normalizeStyle({
          width: `${(canvasWidth - 4).toFixed()}px`,
        })
      }, [
        _withDirectives(_createElementVNode("input", {
          class: "hue-slider-input",
          type: "range",
          min: "0",
          max: "360",
          step: "1",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((hue).value = $event))
        }, null, 512), [
          [_vModelText, hue.value]
        ]),
        _createElementVNode("div", {
          class: "hue-marker",
          style: _normalizeStyle({
            left: `${(hue.value / 360) * 100}%`,
            color: `hsl(${hue.value}, 100%, 50%)`,
          })
        }, null, 4)
      ], 4)
    ])
  ]))
}
}

})